<template>
  <picture class="c-picture--default" data-css="c-picture">
    <img
      class="picture__image"
    	:src="getLMULogo()"
      alt="LMU-Logo"
      data-sizes="auto"
    >
  </picture>
</template>


<script>
export default {
	methods: {
        getLMULogo() {
            return `${this.$store.getters.frontendpath}/img/Newsroom_green_LMU.svg`;
        }
    }
};
</script>
